module.exports = {
  th_title: "ติดต่อ",
  th_title_description: "ติดต่อขอข้อมูลเพิ่มเติม",
  th_description:
    "ติดต่อทีมงาน Auto Rebalance เพื่อสอบถามข้อมูล เราจะทำการติดต่อกลับท่านโดยเร็วที่สุด",
};
